import { Button } from 'reactstrap';

import PromptModal from 'Lib/components/modals/PromptModal';

const ConfirmDateModal = ({ isProcessing, body, buttonLabel, header, onClose, onConfirm }) => {
    const close = () => {
        if (onClose) {
            onClose();
        }
    };

    const confirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    return (
        <PromptModal
            isOpen={true}
            onClose={close}
            header={header}
            body={body}
            buttons={() => {
                if (isProcessing) {
                    return (
                        <Button color="success" disabled={true}>
                            {buttonLabel ? buttonLabel.working : 'Confirming'}
                        </Button>
                    );
                }

                return (
                    <>
                        <Button color="success" onClick={confirm}>
                            {buttonLabel ? buttonLabel.primary : 'Confirm'}
                        </Button>
                        <Button color="secondary" onClick={close}>
                            {buttonLabel ? buttonLabel.secondary : 'Cancel'}
                        </Button>
                    </>
                );
            }}
        />
    );
};

export default ConfirmDateModal;
